module.exports = __webpack_public_path__ + "assets/img/avatar_hop.1bb6b5ed.png";